Shopware.Component.override('sw-extension-uninstall-modal', () => import('./component/sw-extension-uninstall-modal'));
